import React, { Fragment, useContext, useEffect } from 'react';
import ReporteReducidoPie from './ReporteReducidoPie';
//import Spinner from '../../spinner/Spinner';

import { ReporteNavTabs, ReporteTabContent} from './ReporteData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ServicioContext from '../../../../context/servicio/servicioContext';
import AlertaContext from '../../../../context/alerta/alertaContext';

const Reporte = () => {
    const alertaContext = useContext(AlertaContext);
    const { alerta, mostrarAlerta } = alertaContext;

    const servicioContext = useContext(ServicioContext);
    const { mensaje } = servicioContext;

    useEffect(() => {
        if(mensaje) {
            mostrarAlerta(mensaje.msg, mensaje.categoria);
        }
        //eslint-disable-next-line
    }, [mensaje]);

    return (
        <Fragment>
            
            <div id= 'navTab' className='container page'>
                <ul className='nav nav-tabs nav-justified flex-columns'>
                    { alerta ? (<div className={`alerta ${alerta.categoria}`}>{alerta.msg}</div>) : null }
                    {ReporteNavTabs.map((item, index) => {
                        //console.log(ReporteNavTabs);
                        return (
                            <li key={index} className={item.cNameLi}>
                                <a href={item.path} className={item.cNameA} data-toggle={item.dataToggle}>
                                    <FontAwesomeIcon icon={item.icon} /> <span className=''>{item.title}</span>
                                </a>
                            </li>
                        );
                    })}
                </ul>
                <div id='contentTab' className='tab-content'>
                    {ReporteTabContent.map((item, index) => {
                    return(
                        <div key={index} className={item.cName} id={item.id}>
                            {item.component}
                        </div>
                    )
                    })}
                </div>
                <ReporteReducidoPie />
            </div> 
            
      </Fragment>
    )
}

export default Reporte;